// extracted by mini-css-extract-plugin
module.exports = {"whiteOverlay":"GlobalLoaderOverlay_whiteOverlay__4febl","darkText":"GlobalLoaderOverlay_darkText__76jYR","shimmer":"GlobalLoaderOverlay_shimmer___l82X"};